module.exports = __webpack_public_path__ + "img/Closing.0a9524b1.png";